// Used in lesson-form.component.html and lesson-builder-form.component.html

// Angular
import { KeyValue } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";

// Services/Types/Helpers
import { FormHelper } from "#core/helpers";
import { LanguageHelper } from "#helpers/language.helper";
import { EditionId, SubjectId } from "@carnegie-learning/common-types";
import { Asset, AssetAssociation, Edition, Level } from "@carnegie-learning/cure-types";

@Component({
    selector: "lesson-form-fields",
    templateUrl: "./lesson-form-fields.component.html",
    styleUrls: [
        "../../../../../styles/form-styles.scss",
        "./lesson-form-fields.component.scss",
    ],
    standalone: false
})
export class LessonFormFieldsComponent implements OnInit, OnChanges {
    @Input() parent!: UntypedFormGroup;
    @Input() programs: AssetAssociation[] = [];
    @Input() lessonUnits: string[] = [];
    @Input() lessonLevels: Level[] = [];
    @Input() levelLabel = "";
    @Input() selectedAssets: Asset[] = [];
    @Input() subjectId: SubjectId = "";
    @Input() editionId: EditionId = "";

    @Output() languageChange = new EventEmitter<MatSelectChange>();
    @Output() getFormData = new EventEmitter<void>();

    disableProgramSelect = false;

    visibilityOpts: KeyValue<string, string>[] = [];

    constructor(
        public languageHelper: LanguageHelper,
        private formHelper: FormHelper
    ) {}

    ngOnInit() {
        this.visibilityOpts = this.formHelper.getVisibilityOpts();
        // If opening already started form and an invalid value for scorePossible exists, show the error message
        if (
            this.parent?.get("scorePossible")?.value &&
            this.parent?.get("scorePossible")?.invalid
        ) {
            this.parent?.get("scorePossible")?.markAsTouched();
        }
    }

    ngOnChanges() {
        this.parent.patchValue({
            editionIds: [this.editionId],
        });
        this.disableProgramSelect = !!this.selectedAssets?.length;
    }
    onProgramValueChange(editionId: EditionId) {
        this.parent.patchValue({
            editionIds: [editionId],
        });
    }

    trackByProgram(index: number, edition: Edition) {
        if (edition) {
            return edition.editionId;
        }
    }

    languageUpdate(event: MatSelectChange) {
        this.languageChange.emit(event);
    }

    onChange() {
        this.getFormData.emit();
    }

    ifMathProgram() {
        if (
            this.subjectId &&
            this.languageHelper.ifMathLanguage(this.subjectId)
        ) {
            return true;
        }
    }

    setQuillEditorTouched() {
        this.parent.controls.description.markAsTouched();
    }
}
